module.exports = __webpack_public_path__ + "img/Angiogenesis-PRCA_10X_AIC.58e09225.png";